import { useState, useEffect, useRef } from 'react';
import TrainLoader from '../General/TrainLoader';
import { getPBILog } from '../../data/Airtable'; // Adjust the path to where your function is located
import { FormControl, InputLabel, Select, MenuItem, Box } from '@mui/material';

const EITDashboard = () => {
    const [iframeLoaded, setIframeLoaded] = useState(false);
    const [dashboards, setDashboards] = useState([]);
    const [selectedDashboard, setSelectedDashboard] = useState(0);
    const iframeRef = useRef(null);

    const handleFullScreen = () => {
        if (iframeRef.current) {
            if (iframeRef.current.requestFullscreen) {
                iframeRef.current.requestFullscreen();
            } else if (iframeRef.current.mozRequestFullScreen) { // Firefox
                iframeRef.current.mozRequestFullScreen();
            } else if (iframeRef.current.webkitRequestFullscreen) { // Chrome, Safari, and Opera
                iframeRef.current.webkitRequestFullscreen();
            } else if (iframeRef.current.msRequestFullscreen) { // IE/Edge
                iframeRef.current.msRequestFullscreen();
            }
        }
    };

    useEffect(() => {
        const fetchLink = async () => {
            try {
                const tableID = "tblVNsqiF3P7bTwTT";
                const response = await getPBILog(tableID);
                console.log(response);
                if (response && response.length > 0) {
                    if (response.length >= 3) {
                        [response[1], response[2]] = [response[2], response[1]];
                    }
                    // Crosstown Dashboard is a standalone Azure Static Web App (not in Airtable).
                    // Prepended so it appears first in the dropdown.
                    response.unshift({ urls: 'https://ambitious-beach-0aace5d0f.7.azurestaticapps.net' });
                    setDashboards(response);
                } else {
                    console.error('No URL found in the response');
                }
            } catch (error) {
                console.error('Error fetching the dashboard link:', error);
            }
        };

        fetchLink();
    }, []);

    const handleDashboardChange = (e) => {
        setIframeLoaded(false);
        setSelectedDashboard(Number(e.target.value));
    };

    const handleIframeLoad = () => {
        setIframeLoaded(true);
    };

    const iframeSrc = dashboards[selectedDashboard]?.urls || '';

    const spinnerContainerStyle = {
        position: 'fixed', 
        top: '50%', 
        left: '50%', 
        transform: 'translate(-50%, -50%)',
        zIndex: 100,
    };

    return (
        <div style={{ width: '100%', display: 'flex', flexDirection: "column", alignContent: 'center', marginTop:20}}>
            {!iframeLoaded && (
                <div style={spinnerContainerStyle}>
                    <TrainLoader />
                </div>
            )}

            {/* Controls Container */}
            <Box sx={{ width: '100%', display: 'flex', marginBottom: 2 }}>
                <FormControl variant="standard" sx={{ m: 1, minWidth: 180 }}>
                    <InputLabel id="dashboard-label">Dashboard</InputLabel>
                    <Select
                        labelId="dashboard-label"
                        id="dashboard-select"
                        value={selectedDashboard}
                        onChange={handleDashboardChange}
                        label="Dashboard"
                    >
                        {dashboards.map((_, index) => (
                            <MenuItem key={index} value={index}>
                                {index === 0 ? 'Crosstown Dashboard' : index === 1 ? 'Room Equipment' : index === 2 ? 'Wayside Equipment' : index === 3 ? 'Wayside Equipment OLD' : ''}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
                <div style={{ position: 'relative', width: '100%' }}>
                    <button
                        onClick={handleFullScreen}
                        style={{
                            position: 'absolute',
                            top: 0,
                            right: 0,
                            padding: '8px 12px',
                            cursor: 'pointer'
                        }}
                    >
                        Full Screen
                    </button>
                </div>
            </Box>

            <div style={{ display: iframeLoaded ? 'block' : 'none' }}>
                <script src="https://static.airtable.com/js/embed/embed_snippet_v1.js"></script>
                <iframe
                    ref={iframeRef}
                    onLoad={handleIframeLoad}
                    className="airtable-embed airtable-dynamic-height"
                    src={iframeSrc}
                    width="100%"
                    height="750px"
                    title="Equipment Install Tracking Dashboard"
                    style={{ background: 'transparent', border: '1px solid #ccc' }}
                ></iframe>
            </div>
        </div>
    );
};

export default EITDashboard;